// extracted by mini-css-extract-plugin
export default {"card":"Card_card__HKBJO","preview":"Card_preview__0wuJa","title":"Card_title__A-wNb","content":"Card_content__+x+cb","image":"Card_image__Dcuuy"};